"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var UploadInputForDirective = /** @class */ (function () {
    function UploadInputForDirective(element) {
        this.element = element;
        this._queue = null;
        this._inputId = null;
        this.onFileSelected = new core_1.EventEmitter();
        this._element = this.element.nativeElement;
    }
    Object.defineProperty(UploadInputForDirective.prototype, "fileUploadQueue", {
        set: function (value) {
            if (value) {
                this._queue = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UploadInputForDirective.prototype, "inputId", {
        set: function (value) {
            this._inputId = value;
        },
        enumerable: true,
        configurable: true
    });
    UploadInputForDirective.prototype.onChange = function () {
        var files = this.element.nativeElement.files;
        this.onFileSelected.emit(files);
        if (this._queue && this._queue.addFiles && files) {
            this._queue.addFiles(files);
        }
        else if (this._queue && this._queue.addFile && files) {
            for (var i = 0; i < files.length; i++) {
                if (typeof this._inputId == 'number')
                    this._queue.addFile(files[i], this._inputId);
                else
                    this._queue.addFile(files[i]);
            }
        }
        this.element.nativeElement.value = "";
    };
    UploadInputForDirective.prototype.onDrop = function (event) {
        var files = event.dataTransfer.files;
        this.onFileSelected.emit(files);
        if (this._queue && this._queue.addFiles && files) {
            this._queue.addFiles(files);
        }
        else if (this._queue && this._queue.addFile) {
            for (var i = 0; i < files.length; i++) {
                this._queue.addFile(files[i]);
            }
        }
        event.preventDefault();
        event.stopPropagation();
        this.element.nativeElement.value = "";
    };
    UploadInputForDirective.prototype.onDropOver = function (event) {
        event.preventDefault();
    };
    return UploadInputForDirective;
}());
exports.UploadInputForDirective = UploadInputForDirective;
